import React from 'react';
import { motion } from 'framer-motion';
import { ReferralStats } from '../../types/ReferralTypes';

interface ReferralProgressProps {
  stats: ReferralStats;
}

const ReferralProgress: React.FC<ReferralProgressProps> = ({ stats }) => {
  const progress = (stats.progressToNextTier / stats.nextTierThreshold) * 100;

  return (
    <div className="bg-white rounded-2xl shadow-sm p-8 border border-gray-100">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Progress to Next Tier</h2>
      
      <div className="relative pt-1">
        <div className="flex items-center justify-between mb-2">
          <div>
            <span className="text-sm font-medium text-gray-900">
              {stats.progressToNextTier} / {stats.nextTierThreshold} Invites
            </span>
          </div>
          <div>
            <span className="text-sm font-medium text-gray-900">{Math.round(progress)}%</span>
          </div>
        </div>
        
        <div className="flex h-4 overflow-hidden bg-gray-100 rounded-full">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="flex flex-col justify-center overflow-hidden bg-gradient-to-r from-airbnb-red to-red-400"
          />
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-center p-4 bg-gray-50 rounded-xl">
            <div className="h-12 w-12 flex items-center justify-center bg-red-100 rounded-lg">
              <svg className="h-6 w-6 text-airbnb-red" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-900">Next Milestone</p>
              <p className="text-sm text-gray-500">5 more invites</p>
            </div>
          </div>

          <div className="flex items-center p-4 bg-gray-50 rounded-xl">
            <div className="h-12 w-12 flex items-center justify-center bg-green-100 rounded-lg">
              <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-900">Reward Amount</p>
              <p className="text-sm text-gray-500">$50 per invite</p>
            </div>
          </div>

          <div className="flex items-center p-4 bg-gray-50 rounded-xl">
            <div className="h-12 w-12 flex items-center justify-center bg-blue-100 rounded-lg">
              <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-900">Current Tier</p>
              <p className="text-sm text-gray-500">{stats.currentTier}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralProgress;